import { Details } from '@cc-shopping/ui/primitives/Details';
import { Box, type SxProps, Typography } from '@mui/material';
import { forwardRef, type PropsWithChildren } from 'react';

export const DetailsAccordionAccordion = forwardRef<
  HTMLDivElement,
  PropsWithChildren<{
    defaultExpanded?: boolean;
    title: string;
    additionalDetailsStyles?: SxProps;
    additionalSummaryStyles?: SxProps;
    onChange: (expanded: boolean) => void;
  }>
>(
  (
    {
      additionalDetailsStyles,
      additionalSummaryStyles,
      title,
      defaultExpanded = false,
      onChange,
      children,
    },
    ref,
  ) => {
    return (
      <Details
        variant="simple"
        SummaryComponent={
          <Box
            ref={ref}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: '24px',
            }}
          >
            <Typography variant="smallHeadline" component="h3">
              {title}
            </Typography>
            <Box
              component="span"
              className="mask-icon mask-icon-expand-more expand-icon"
              sx={{
                width: '30px',
                height: '30px',
                backgroundColor: 'common.black',
              }}
            />
          </Box>
        }
        summaryComponentProps={{
          itemProp: 'name',
          sx: {
            padding: 3,
            ...additionalSummaryStyles,
          },
        }}
        detailsProps={{
          open: defaultExpanded,
          onToggle: ({ newState }) => onChange(newState === 'open'),
          sx: {
            border: '1px solid',
            borderColor: 'neutral.lighter',
            '&> summary:hover': {
              backgroundColor: 'blues.lightest',
              outline: { md: '2px solid' },
              outlineColor: { md: 'blues.light' },
              position: 'relative',
              zIndex: 1,
            },
            ...additionalDetailsStyles,
          },
        }}
      >
        <Box
          sx={{
            padding: 3,
            paddingBottom: { xs: 4, sm: 'calc(1.75rem + 0.25 * (100vw - 27.5rem) / 54.5)' },
          }}
        >
          {children}
        </Box>
      </Details>
    );
  },
);
